import LogLevel from './logLevels';

/**
 * A close copy of the Consola Browser reporter. We've customized the badger
 * and level colors to correspond to our custom LogLevels.
 */
export default class HwpReporter {
	constructor() {
		this.defaultColor = '#7f8c8d'; // Gray
		this.levelColorMap = {
			[LogLevel.Error]: '#c0392b', // Red
			[LogLevel.Warn]: '#f39c12', // Yellow
			[LogLevel.Info]: '#00BCD4', // Cyan
			[LogLevel.Debug]: '#0000ff', // blue
		};
		this.typeColorMap = {
			success: '#2ecc71', // Green
		};
	}

	log(logObj) {
		// console.log('[HwpReporter][log]', { logObj });

		const { level, tag = '', args } = logObj;
		let { type = '' } = logObj;

		let consoleLogFn = console[type];
		if (!consoleLogFn) {
			if (level < 1) {
				consoleLogFn = console.__error || console.error;
			} else if (level === 1) {
				consoleLogFn = console.__warn || console.warn;
			} else {
				consoleLogFn = console.__log || console.log;
			}
		}

		// Type
		type = type !== 'log' ? type : '';

		// Styles
		const color = this.typeColorMap[type] || this.levelColorMap[level] || this.defaultColor;
		const style = `
		  background: ${color};
		  border-radius: 0.5em;
		  color: white;
		  font-weight: bold;
		  padding: 2px 0.5em;
		`;

		const badge = `%c${[tag, type]
			.filter(Boolean)
			.map((str) => `[${str.toUpperCase()}]`)
			.join('')}`;

		// Log to the console
		if (typeof args[0] === 'string') {
			consoleLogFn(
				`${badge}%c ${args[0]}`,
				style,
				'', // Empty string as style resets to default console style
				...args.slice(1),
			);
		} else {
			consoleLogFn(badge, style, ...args);
		}
	}
}
